import { render, staticRenderFns } from "./compression-chart.vue?vue&type=template&id=51a15426&scoped=true"
import script from "./compression-chart.vue?vue&type=script&lang=js"
export * from "./compression-chart.vue?vue&type=script&lang=js"
import style0 from "./compression-chart.vue?vue&type=style&index=0&id=51a15426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a15426",
  null
  
)

export default component.exports